import { useContext, useEffect, useState } from "react";
import { IoIosClose } from "react-icons/io"
import { CarritoContext } from "../context/CarritoContext";
import { formatter, guardarLocalStorage } from "../resources/funciones";
import { useMobileDetection } from "../hook/useMobileDetection";
import { Link, useNavigate } from "react-router-dom";
import { getPreciosActualizados } from "../api/azpitia";
import {useTranslation} from 'react-i18next'
import {ContadorProducto} from './ContadorProducto'

export const Carrito = () => {

    const { carrito, eliminarProducto, disminuirCantidad, aniadirCantidad, totalCarrito } = useContext(CarritoContext)

    const [carritoActualizado, setCarritoActualizado] = useState([])

    const isMobile = useMobileDetection()
    const navigate = useNavigate()
    const { t } = useTranslation()

    const subTotalPorProducto = (producto) => {
        const precio = producto?.ProdPrecD ? parseFloat(producto?.ProdPrecD) : parseFloat(producto?.ProdPrecN);
        const subTotal = precio * producto?.Cantidad
        return formatter.format(subTotal);
    }

    const irComprar = () => {
        if (carrito?.length > 0) {
            navigate("/compra")
        }

    }

    // Función para actualizar los nombres y precios en el carrito
    const actualizarProducto = (productoCarrito, preciosActualizados) => {
        for (let productoPrecio of preciosActualizados) {
            if (productoCarrito.ProdCod === productoPrecio.ProductoC) {
                productoCarrito.ProdNom = productoPrecio.ProductoNombre;
                productoCarrito.ProdPrecN = productoPrecio.ProductoPrecioN;
                productoCarrito.ProdPrecD = productoPrecio.ProductoPrecioD;
                break;
            }
        }
        return productoCarrito;
    }

    const obtenerPreciosActualizados = async (dataPOST) => {
        const { preciosActualizados } = await getPreciosActualizados(dataPOST)

        // Actualizar nombres y precios en el carrito usando map
        let carritoActualizado = carrito.map(c => actualizarProducto(c, preciosActualizados));
        setCarritoActualizado(carritoActualizado)

        guardarLocalStorage(carritoActualizado, "carrito")
    }

    useEffect(() => {

        const listaIdProductos = carrito.map(c => ({
            ProductoC: c.ProdCod
        }))
        const dataPOST = {
            list: listaIdProductos
        }
        obtenerPreciosActualizados(dataPOST)
        // eslint-disable-next-line
    }, [carrito])

    return (
        <div className="container" style={{ minHeight: "100vh", paddingTop:"94px"}}>
            <div className="row">
                <div className="col-md-8 detalle">
                    <div className="section-header mt-4">
                        <h2>{t("tienda_carrito_cabecera")}</h2>
                    </div>
                    
                    {
                        carritoActualizado?.length > 0 ? (
                            carritoActualizado?.map(c => (
                                <div className="detalle-producto" key={c?.ProdCod}>
                                    <IoIosClose className="cart-remove" onClick={(e) => eliminarProducto(e, c?.ProdCod)} />
                                    <div className="row detalle-item">
                                        <div className="col-md-3 detalle-img">
                                            <img src={c?.ProdImg} alt="..." className="img-producto" />
                                        </div>

                                        <div className={`col-md-4 detalle-box ${isMobile && "text-center"}`}>
                                            <div className={`cart-product-title`}>{c?.ProdNom}</div>
                                            <div>
                                                {
                                                    (!c?.ProdPrecD) ? (
                                                        <span className="cart-price">{formatter.format(c?.ProdPrecN)}</span>
                                                    ) : (
                                                        <span>
                                                            <span className="cart-price-discount">{formatter.format(c?.ProdPrecN)}</span>
                                                            <span className="ms-2 cart-price">{formatter.format(c?.ProdPrecD)}</span>
                                                        </span>
                                                    )
                                                }
                                            </div>
                                        </div>

                                        <div className="col-md-2 d-flex" style={{padding: "2px 0"}}>
                                            <ContadorProducto contador={c?.Cantidad} aumentarCallback={()=>aniadirCantidad(c?.ProdCod)} disminuirCallback={()=>disminuirCantidad(c?.ProdCod)}/>
                                            {/* <div className="detalle-cantidad p-auto w-100">                                                
                                                <div className="btn-group btn-group-sm w-100">
                                                    <button className="btn btn-primario" onClick={(e) => disminuirCantidad(c?.ProdCod)}>-</button>
                                                    <span className="btn" style={{background:"white"}}>{c?.Cantidad}</span>
                                                    <button className="btn btn-primario" onClick={(e) => aniadirCantidad(c?.ProdCod)}>+</button>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="col-md-2 detalle-subtotal" style={{ padding: "5px 0" }}>
                                            {subTotalPorProducto(c)}
                                        </div>
                                    </div>
                                    <hr/>
                                </div>
                            ))
                        ) : (
                            <Link className="nav-link text-center mt-3" to="/tienda">
                                {t("tienda_carrito_btn_añadir")}
                            </Link>
                        )
                    }
                    <div className="detalle-adicional">

                    </div>
                </div>
                <div className={`col-md-4  ${isMobile?'mb-4':''}`}>
                    <div className="mt-4 floating-card bg-secundario pb-3 pt-3">                        
                        <div className="d-flex justify-content-between">
                            <div>{t("tienda_carrito_detalle_subtotal")}</div>
                            <div>{totalCarrito()}</div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div>{t("tienda_carrito_detalle_envio")}</div>
                            <div>{formatter.format(0)}</div>
                        </div>                        
                        <hr/>
                        <div className="d-flex justify-content-between mt-2">
                            <div>{t("tienda_carrito_detalle_total")}</div>
                            <div>{totalCarrito()}</div>
                        </div>

                        <div className="mt-4">
                            <button type="button" className="btn btn-primario w-100" onClick={irComprar}  disabled={carrito?.length > 0 ? false : true}>{t("tienda_carrito_detalle_btn_procesar")}</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
